import React from 'react';

import StarRating from './StarRating';

const ReviewCard = ({ review }) => {
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    return new Date(dateStr)?.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  };

  const reviewerName = review?.reviewer?.full_name || 'Anonymous';
  const initials = reviewerName?.split(' ')?.map(n => n?.[0])?.join('')?.toUpperCase()?.slice(0, 2);

  return (
    <div className="bg-muted/10 border border-border rounded-lg p-4 space-y-3">
      {/* Header */}
      <div className="flex items-start justify-between">
        <div className="flex items-center space-x-3">
          <div className="w-9 h-9 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
            {review?.reviewer?.avatar_url ? (
              <img src={review?.reviewer?.avatar_url} alt={reviewerName} className="w-full h-full rounded-full object-cover" />
            ) : (
              <span className="text-xs font-bold text-primary">{initials}</span>
            )}
          </div>
          <div>
            <p className="text-sm font-medium text-foreground">{reviewerName}</p>
            <div className="flex items-center space-x-2">
              <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${review?.role === 'seller' ? 'bg-primary/10 text-primary' : 'bg-success/10 text-success'}`}>
                {review?.role === 'seller' ? 'Seller Review' : 'Buyer Review'}
              </span>
              <span className="text-xs text-muted-foreground">{formatDate(review?.created_at)}</span>
            </div>
          </div>
        </div>
        <StarRating rating={review?.rating || 0} size={14} showValue={false} />
      </div>

      {/* Review Text */}
      {review?.review_text && (
        <p className="text-sm text-muted-foreground leading-relaxed">{review?.review_text}</p>
      )}

      {/* Sub-ratings */}
      {(review?.communication_rating || review?.accuracy_rating || review?.shipping_rating) && (
        <div className="grid grid-cols-3 gap-2 pt-2 border-t border-border">
          {review?.communication_rating && (
            <div className="text-center">
              <p className="text-xs text-muted-foreground mb-1">Communication</p>
              <StarRating rating={review?.communication_rating} size={10} showValue={false} />
            </div>
          )}
          {review?.accuracy_rating && (
            <div className="text-center">
              <p className="text-xs text-muted-foreground mb-1">Accuracy</p>
              <StarRating rating={review?.accuracy_rating} size={10} showValue={false} />
            </div>
          )}
          {review?.shipping_rating && (
            <div className="text-center">
              <p className="text-xs text-muted-foreground mb-1">Shipping</p>
              <StarRating rating={review?.shipping_rating} size={10} showValue={false} />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ReviewCard;
